import template from './catalog.html';
import controller from './catalog.controller';

const menuCatalogComponent = {
  restrict: 'E',
  bindings: {
    condensed: '@',
    productIds: '=',
    select: '@',
    selectedProducts: '=',
    chooseProducts: '=?',
    menu: '=?'
  },
  template,
  controller
};

export default menuCatalogComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/catalog/catalog.component.js
 **/